export default __webpack_public_path__ + "static/media/logo-dark.c9fb389f.svg";